import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, Transition as _Transition, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "crm:hidden crm:items-center crm:lg:flex" }
const _hoisted_2 = { class: "crm:mr-2" }
const _hoisted_3 = { class: "switch crm:hidden crm:lg:inline-block" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = { class: "crm:w-full crm:flex crm:pb-2 crm:items-center crm:justify-between crm:px-4 crm:border-b crm:lg:hidden crm:lg:px-0" }
const _hoisted_6 = { class: "crm:fixed crm:z-[10] crm:bottom-0 crm:m-0 crm:flex crm:w-full crm:border-t crm:bg-white crm:lg:relative crm:lg:w-auto crm:lg:border-0" }
const _hoisted_7 = { class: "crm:mb-4 crm:mt-4 crm:flex crm:w-full crm:justify-center crm:px-4 crm:lg:justify-start" }
const _hoisted_8 = {
  key: 1,
  class: "crm:mt-2 crm:mb-2 crm:flex crm:flex-wrap crm:items-center"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "crm:ml-4 crm:flex crm:items-center" }

import {computed, reactive, inject, onMounted} from "vue";
import {cloneDeep} from "lodash";
import frameworkBaseInstance from "fallco-frontend-framework/src/vue/base_instance";
import {useComponent, useComponentClassesToRender} from "fallco-frontend-framework/src/vue/composable/useComponent";
import {useRoute, useRouter} from "vue-router";
import { UseBaseTableFilter } from "./UseBaseTableFilter.js"
import {delete_cross} from '../../svg/svgs.js'
import moment from 'moment'


const __default__ = {
  inheritAttrs: false,
};

export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'BaseTableBackendFilter',
  props: {
  /**
   * Dati dei filtri
   */
  filters: {
    type: [Object, Array],
    default() {
      return {};
    },
    required: true,
  },
  /**
   * Dati default dei filtri
   */
  filtersDefault: {
    type: [Object, Array, null],
    default() {
      return {};
    },
    required: true,
  },
  /**
   * Se true blocca il push nell'url dei filtri applicati
   * Questo è stato fatto per i filtri lato back all'interno di modali.
   * Poichè sarebbero da collegare al fatto che se chiudo la modale dove sono contenuti, dovrebbero sparire dall'url
   * i filtri applicati. Non è semplice poichè dovresti controllare se nella pagina sottostante non ci sono altri filtri applicati.
   * Per cui al momento per non overcomplicare o aggiunto un'opzione per spegnere il push dell'url dei filtri nelle modali.
   */
  blockPushToUrl: {
    type: Boolean,
    default: false
  }
},
  emits: [
  /**
   *
   */
  'update:filters'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Renderizza e gestisce i filtri di una tabella.
 * Inoltre per ogni filtro applicato, mostra un tag associato
 */
const router = useRouter();
const route = useRoute();

/**
 * @inject {eseguiAjax}
 */
const eseguiAjax = inject('eseguiAjax')

/**
 * @inject {updateAjaxParams}
 */
const updateAjaxParams = inject('updateAjaxParams')

/**
 * @inject {httpParams}
 */
const httpParams = inject('httpParams')

const filtersRef = reactive({
  isFiltersTabOpen: false,
  filtriAttivi: {},
  sortingActived: {},
  colonnaOrdinata: null,
  colonnaOrdinataVerso: null
})

const UseBaseTableFilterRef = UseBaseTableFilter(route, router, filtersRef);

const props = __props

const emits = __emit

/**
 * @provides {updateIsEseguiPaginazione}
 */
const updateIsEseguiPaginazione = inject('updateIsEseguiPaginazione')


async function deleteSingleFilter(filterKey) {
  let filtriPresenti = cloneDeep(props.filters);
  filtriPresenti[filterKey].value = "";
  delete filtersRef.filtriAttivi[filterKey];
  emits('update:filters',filtriPresenti)
  setTimeout(() => {
    postFilters();
  }, 100)
}

/**
 * resetta i filtri precedentemente impostati
 * @returns {Promise<void>}
 */
async function resetFilters() {
  filtersRef.filtriAttivi = {};
  if(props.filtersDefault) {
    let filtriPresenti = cloneDeep(props.filtersDefault);
    emits("update:filters", filtriPresenti);
  }

  UseBaseTableFilterRef.toggleOpen();

  if(!props.blockPushToUrl) await UseBaseTableFilterRef.updateURLQuery(httpParams);

  await updateAjaxParams({filters: null, pagination: {currentPage: 1}});
  await eseguiAjax();
  await updateIsEseguiPaginazione(true)
}

/**
 *
 * @return {Promise<void>}
 */
async function postFilters() {
  let filtri = cloneDeep(props.filters);
  filtersRef.filtriAttivi = {};
  if(filtri) {
    let filtriDaPostare = frameworkBaseInstance.BaseVueUtils.prepareDataToPost(
        filtri
    );

    Object.keys(filtriDaPostare).forEach((filtro) => {
      if (
          filtriDaPostare[filtro] == null ||
          filtriDaPostare[filtro] === "" ||
          (filtri[filtro].type !== undefined &&
              filtri[filtro].type === "boolean" &&
              filtriDaPostare[filtro] === "0")
      ) {
        delete filtriDaPostare[filtro];
      }
    });
    await popolaFiltriAttivi(filtriDaPostare, filtri);
    if(!props.blockPushToUrl)  await UseBaseTableFilterRef.updateURLQuery(httpParams, filtriDaPostare);
    await updateAjaxParams({filters: filtriDaPostare, pagination: {currentPage: 1}});
    await eseguiAjax();
    await updateIsEseguiPaginazione(true)
    UseBaseTableFilterRef.toggleOpen(false);
  }
}

// Gestione e renderizzazione delle classi html dell'elemento root
const classToRender = computed(() => {
  return useComponentClassesToRender(props, {
    ...{
      toggleBar: {
        base: {
          value:
              "crm:mb-2 crm:flex crm:w-full crm:items-center crm:justify-between crm:bg-grey-150 crm:relative",
          condition: true,
        },
      },
      switchSlider: {
        base: {
          value: "slider round",
          condition: true,
        },
      },
    },
  });
});


const componentUtilities = useComponent();

const isMobile = computed(() => {
  return componentUtilities.is_mobile_view.value;
});


/**
 *
 * @return {Promise<void>}
 */
async function applyRouteQuery() {
  let applicaQuery = cloneDeep(props.filters);
  if (route && route.query) {
    if (route.query.filter) {
      let filtri = UseBaseTableFilterRef.convertFilterStringToJson(route.query.filter);
      Object.keys(filtri).forEach((routeKey) => {
        if (
            props.filters[routeKey] !== undefined &&
            props.filters[routeKey]["value"] !== undefined
        ) {
          applicaQuery[routeKey].value = filtri[routeKey];
        }
      });
    emits("update:filters", applicaQuery);
    }
  }
  let filtersUpdated = await UseBaseTableFilterRef.prepareFilters(applicaQuery);

  await popolaFiltriAttivi(filtersUpdated, applicaQuery)
  await updateAjaxParams({filters: filtersUpdated, pagination: {currentPage: 1}})
  await eseguiAjax();
  await updateIsEseguiPaginazione(true)
}

/**
 *
 * @param filtriSettings
 * @param filtro
 * @param filtri
 * @return {string|string|*}
 */
function formatFiltriAttivi(filtriSettings, filtro, filtri) {
  const _isBoolean = ()  => filtriSettings[filtro].type === "boolean";
  const _haveType = () => filtriSettings[filtro].type !== undefined;
  const _isDate = () => filtriSettings[filtro].type === "data";

  return _haveType() && _isBoolean() ? (filtri[filtro] === '1' ? "si" : 'no') : _isDate() ? moment(filtri[filtro], 'YYYY-MM-DD').format('DD/MM/YYYY') : filtri[filtro]
}

/**
 *
 * @param filtri
 * @param filtriSettings
 */
function popolaFiltriAttivi(filtri, filtriSettings) {
  const isFilterPopulated = (filtro) => {
    return filtri[filtro] != null || filtri[filtro] !== "";
  }

  Object.keys(filtri).forEach((filtro) => {
    if (
        isFilterPopulated(filtro)
    ) {
      filtersRef.filtriAttivi[filtro] = {
        name: filtro,
        value: formatFiltriAttivi(filtriSettings, filtro, filtri),
      };
    }
  });
  delete filtersRef.filtriAttivi.live_filter;
}

/**
 * @inject {updateHaveFilters}
 */
const updateHaveFilters = inject('updateHaveFilters')

onMounted(() => {
  updateHaveFilters(true);
  setTimeout(() => {
    applyRouteQuery();
  }, 100);
});

return (_ctx, _cache) => {
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_form = _resolveComponent("base-form")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "crm:m-0 crm:flex" }, _ctx.$attrs), [
      _createElementVNode("div", {
        class: _normalizeClass(classToRender.value.toggleBar)
      }, [
        _withDirectives(_createVNode(_component_base_button, {
          "onClick:cta": _cache[0] || (_cache[0] = $event => (_unref(UseBaseTableFilterRef).toggleOpen()))
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createTextVNode(" Filtra ", -1 /* CACHED */)),
            _renderSlot(_ctx.$slots, "filter-icon")
          ]),
          _: 3 /* FORWARDED */
        }, 512 /* NEED_PATCH */), [
          [_vShow, isMobile.value]
        ]),
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(filtersRef.isFiltersTabOpen ? "Chiudi" : "Apri") + " i filtri di ricerca", 1 /* TEXT */),
          _createElementVNode("label", _hoisted_3, [
            _createElementVNode("input", {
              type: "checkbox",
              name: "filter_open",
              checked: filtersRef.isFiltersTabOpen
            }, null, 8 /* PROPS */, _hoisted_4),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = $event => (_unref(UseBaseTableFilterRef).toggleOpen())),
              class: _normalizeClass([
              classToRender.value.switchSlider,
              filtersRef.isFiltersTabOpen ? 'slider-active' : '',
            ])
            }, null, 2 /* CLASS */)
          ])
        ]),
        _createCommentVNode(" @slot "),
        _renderSlot(_ctx.$slots, "results")
      ], 2 /* CLASS */)
    ], 16 /* FULL_PROPS */),
    (filtersRef.isFiltersTabOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "crm:fixed crm:z-[9] crm:left-0 crm:top-[65px] crm:mb-2 crm:h-full crm:w-full crm:overflow-scroll crm:bg-white crm:pt-4 crm:pr-0 crm:pb-24 crm:lg:relative crm:lg:top-0 crm:lg:overflow-auto crm:lg:pb-0",
          onKeydown: _withKeys(postFilters, ["enter"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Filtri", -1 /* CACHED */)),
            _createElementVNode("span", {
              class: "crm:cursor-pointer",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_unref(UseBaseTableFilterRef).toggleOpen()), ["prevent"]))
            }, [
              _renderSlot(_ctx.$slots, "close-filter-mobile", {}, () => [
                _createVNode(_component_base_icon, {
                  icon: _unref(delete_cross),
                  stroke: "#000"
                }, null, 8 /* PROPS */, ["icon"])
              ])
            ])
          ]),
          _createVNode(_Transition, { name: "filtri-expand" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_base_form, {
                  name: "baseFormFilters",
                  data: __props.filters,
                  actionsSetting: {'continue': {show: false}, 'reset': {show:false}, 'confirm':{show: false}}
                }, {
                  actionsLeft: _withCtx(({formIsValid, formNotComplete}) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_base_button, {
                          type: "button",
                          class: "crm:mr-2!",
                          "onClick:cta": resetFilters
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" Svuota ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_base_button, {
                          mode: "confirm",
                          "onClick:cta": postFilters,
                          state: formIsValid ? 'active' : 'disable'
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Applica Filtri ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["state"])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "filters")
                  ]),
                  _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["data"])
              ])
            ]),
            _: 3 /* FORWARDED */
          })
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    (filtersRef.filtriAttivi && Object.keys(filtersRef.filtriAttivi).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "crm:ml-2 crm:w-full" }, [
            _createElementVNode("strong", null, "Filtri attivi: ")
          ], -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtersRef.filtriAttivi, (filtroAttivo, filtroAttivoKey) => {
            return (_openBlock(), _createElementBlock("div", {
              key: filtroAttivoKey,
              onClick: _withModifiers($event => (deleteSingleFilter(filtroAttivoKey)), ["prevent"]),
              class: "crm:m-1 crm:flex crm:cursor-pointer crm:justify-between crm:rounded-xl crm:border-2 crm:bg-[#00375F] crm:py-1 crm:px-2 crm:text-xs crm:text-white crm:hover:bg-white crm:hover:text-[#00375F]"
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(UseBaseTableFilterRef).formatFilter(filtroAttivo.name)) + ": " + _toDisplayString(filtroAttivo.value), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_10, [
                _renderSlot(_ctx.$slots, "delete-filter", {}, () => [
                  _cache[7] || (_cache[7] = _createTextVNode("X", -1 /* CACHED */))
                ])
              ])
            ], 8 /* PROPS */, _hoisted_9))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})